// extracted by mini-css-extract-plugin
export default {"image":"KX-z","loaded":"LX-z"};